import { auth, fireStore } from '../../firebase'

export default ({
  state: {
    user: null,
    userData: {
      Name: '',
      Role: '',
      Company: '',
      Access: [],
      UID: ''
    }
  },
  mutations: {
    setUser (state, payload) {
      state.user = payload
    },
    setUserData (state, payload) {
      state.userData = payload
    }
  },
  actions: {
    signUserUp ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      auth.createUserWithEmailAndPassword(payload.email, payload.password)
        .then(
        user => {
          commit('setLoading', false)
          const newUser = {
            id: user.uid
          }
          commit('setUser', newUser)
        }
        ).catch(
        error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        }
        )
    },
    signUserIn ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      auth.signInWithEmailAndPassword(payload.email, payload.password)
        .then(
        user => {
          commit('setLoading', false)
          const newUser = {
            id: user.uid
          }
          commit('setUser', newUser)
        }
        ).catch(
        error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        }
        )
    },
    autoSignIn ({ commit }, payload) {
      commit('setUser', {
        id: payload.uid
      })
    },
    fetchUserData ({ commit, getters }) {
      commit('setLoading', true)
      fireStore.collection('Users').where('UID', '==', getters.user.id)
        .get()
        .then(data => {
          let updateUser = {}
          data.forEach(doc => {
            if (doc.data().Role !== undefined) {
              let role = doc.data().Role
              updateUser = doc.data()
              fireStore.collection('Roles').doc(role)
              .get()
              .then(access => {
                if (access.data().Access !== undefined) {
                  updateUser.Access = access.data().Access
                }
                commit('setLoading', false)
                commit('setUserData', updateUser)
              })
            }
          })
        })
        .catch(error => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    logout ({ commit }) {
      auth.signOut()
      commit('setUser', null)
      commit('setUserData', {
        Name: '',
        Role: '',
        Company: '',
        Access: [],
        UID: ''
      })
    }
  },
  getters: {
    user (state) {
      return state.user
    },
    userData (state) {
      return state.userData
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/user/index.js